/* Vřídlo rituals: small behaviour of the card grid (the reveal itself comes from vr-motion.js).
   - pauses the idle animations while the section is off screen (class .is-offscreen)
   - arrow keys, Home and End move focus between the cards (including the closing all-products card)
   Idempotent, supports the theme editor (shopify:section:load / unload), no console output. */
(function () {
  var registry = new Map();

  function cleanupFor(host) {
    var fn = registry.get(host);
    if (fn) {
      fn();
      registry.delete(host);
    }
  }

  function init(host) {
    if (!host || registry.has(host)) return;
    var abort = new AbortController();
    var observer = null;
    var visible = true;

    function paint() {
      host.classList.toggle('is-offscreen', document.hidden || !visible);
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        visible = entries[entries.length - 1].isIntersecting;
        paint();
      }, { rootMargin: '120px 0px' });
      observer.observe(host);
    }
    document.addEventListener('visibilitychange', paint, { signal: abort.signal });

    host.addEventListener('keydown', function (event) {
      var current = event.target && event.target.closest ? event.target.closest('.vr-ritual, .vr-ritual-all') : null;
      if (!current || event.altKey || event.ctrlKey || event.metaKey) return;
      var links = Array.prototype.slice.call(host.querySelectorAll('.vr-ritual, .vr-ritual-all'));
      var index = links.indexOf(current);
      var next = index;
      if (event.key === 'ArrowRight') next = Math.min(links.length - 1, index + 1);
      else if (event.key === 'ArrowLeft') next = Math.max(0, index - 1);
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = links.length - 1;
      else return;
      event.preventDefault();
      if (next !== index && links[next]) links[next].focus();
    }, { signal: abort.signal });

    registry.set(host, function () {
      abort.abort();
      if (observer) observer.disconnect();
      host.classList.remove('is-offscreen');
    });
    host.setAttribute('data-vr-rituals-ready', '');
  }

  function initAll(scope) {
    var root = scope || document;
    if (root.matches && root.matches('[data-vr-rituals]')) init(root);
    root.querySelectorAll('[data-vr-rituals]').forEach(init);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var hosts = event.target.querySelectorAll ? event.target.querySelectorAll('[data-vr-rituals]') : [];
    hosts.forEach(cleanupFor);
  });
})();
